// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import React from "react";

const AutumnAnimation = () => {

    return (
        <div>
            <div className="setAutumn">
                <div className="leaves"></div>
            </div>
        </div>
    );
};

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default AutumnAnimation;
